// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".47a1f2a37082293d1f30db5208f1b7c4.js";
};